export default __webpack_public_path__ + "static/media/Hakamine.fc89f2bb.png";